export var AnnounceFilterCleared = "Filter selection cleared";
export var AnnounceFilterResultCount = "Showing {0} filtered items.";
export var AnnounceFinishedLoadingItems = "Finished loading items";
export var AnnounceLoadingItems = "Loading items";
export var DropdownClearActionText = "Clear";
export var Loading = "Loading...";
export var NoFilterResults = "No items matched the supplied filter";
export var Searching = "Searching...";
